<template xmlns="http://www.w3.org/1999/html">
  <div class="show">
    <div class="top">
      <div class="top_content" >
        <div class="log_img">
          <!--          轮播图-->
          <el-carousel :interval="2500" height="350px" v-if="this.imges[0]!=null">
            <el-carousel-item v-for="(item,index) in imges" :key="index" >
              <img :src="item" style="max-height:100%;max-width:100% ">
            </el-carousel-item>
          </el-carousel>
        </div>
        <!--        空白-->
        <div class="blank1"></div>



        <!--        通知公告左侧导航栏-->
        <el-button  circle style="position: fixed;
        left:0px;
        top:400px;
        width: 50px;
        height: 50px;
        color: white;
        background: rgb(31, 56, 128);"
                    v-on:mouseover="isShow()"
        >{{$t('tabs.navigation')}}</el-button>
        <!--        通知公告右侧导航栏-->
        <el-button  circle style="position: fixed;
        right:0px;
        top:400px;
        width: 50px;
        height: 50px;
        color: white;
        background: rgb(31, 56, 128);"
                    v-on:mouseover="showQQgroup = true"
        >{{$t('tabs.groups')}}</el-button>
        <div class="announce_left" style="top:200px;">
          <el-button style="float: right;width: 20px;height: 20px;background-color:transparent;color: white;" v-show="show" @click="isNotShow()">X</el-button>
          <!--          <el-button v-for="(item,index) in news" style="width: 200px;margin-left: 0px;" @click="goToAnnounce(index)">{{item.title}}</el-button>-->
          <el-button v-for="(item,index) in news" style="width: 200px;margin-left: 30px;" v-on:mouseover="goToAnnounce(index)" v-show="show" >{{item.title}}</el-button>
          <el-button style="width: 200px;margin-left: 30px;" v-on:mouseover="goToAnnounce(9)" v-show="show">{{this.$t('tabs.info')}}</el-button>
          <el-button style="width: 200px;margin-left: 30px;" v-on:mouseover="goToAnnounce(8)" v-show="show">{{this.$t('tabs.download')}}</el-button>
          <el-button style="width: 200px;margin-left: 30px;" v-on:mouseover="goToAnnounce(10)" v-show="show">{{this.$t('tabs.sign_up')}}</el-button>

        </div>
        <!--        通知公告内容-->
        <div class="announce" >
          <div v-for="(item,index) in news">
            <div :id="index" v-html="item.content"  class="details-box" >
            </div>
            <el-button v-if="index==5" type="primary" @click="goToShow">{{ $t('login.enroll_now') }}</el-button>

          </div>

        </div>
        <!--        通知通告-->
        <div class="notices" v-if="isCommitValue==1">
          <!--          <p>通知公告</p>-->
          <!--          id="notices_title"-->
          <div class="notices_title"  ref="notices_title" :id="9">
            {{$t('tabs.announcement')}}
            <span class="notices_more"><a :href="'/#/fannounceList'" style="color: gray;font-size: 15px;">{{$t('tabs.more')}}</a></span>
            <div class="notices_line"></div>
          </div>
          <div class="bullist" >
            <ul>
              <li v-for="(item,index) in announce" >
                <div class="date" v-if="index < 10">
                  <p class="day">{{item.month}}-{{item.day}}</p>
                  <p class="year">{{item.year}}</p>
                </div>
                <div class="text" >
                  <a :href="'/#/fannounceShow?id='+item.id" style="color: black">
                    {{item.title}}
                  </a>
                  <div  v-if="index==0"  style="float: right;margin-right: 20px;background: rgb(156,0,0);height: 18px;width:36px;border-radius: 3px;"><span style="color: #dcdfe6;font-size: 12px;line-height: 18px;display: flex;justify-content: center;">new</span></div>
                </div>
              </li>

            </ul>
          </div>

        </div>
        <!--      资料下载  tech  -->
        <div class="tech" v-if="isCommitValue==1">
          <!--          id="tech_title"-->
          <div class="tech_title"  ref="tech_title" :id="8">
            {{$t('tabs.download')}}
            <span class="tech_more"><a :href="'/#/fileListShow'" style="color: gray;font-size: 15px;">{{$t('tabs.more')}}</a></span>
            <div class="tech_line"></div>
          </div>
          <div class="bullist" >
            <ul>
              <li v-for="(item,index) in fileDownload" >
                <div class="date" v-if="index < 10">
                  <p class="day">{{item.month}}-{{item.day}}</p>
                  <p class="year">{{item.year}}</p>
                </div>
                <div class="text" v-if="index < 10">
                  <a style="" @click="downloadFile(item)">
                    <i class="dot" @click="downloadFile(item)"> </i><strong>【Download】</strong>{{item.name}}
                  </a>
                  <!--                  <span  v-if="index==0" style="float: right;margin-right: 20px;background: rgb(200,0,0);height: 18px;width:36px;border-radius: 3px;margin-top: 8px">new</span>-->
                  <div  v-if="index==0"  style="float: right;margin-right: 20px;background: rgb(156,0,0);height: 18px;width:36px;border-radius: 3px;">
                    <span style="color: #dcdfe6;font-size: 12px;line-height: 18px;display: flex;justify-content: center;">new</span>
                  </div>
                </div>

              </li>

            </ul>
          </div>
        </div>
        <!--        报名登记-->
        <div class="sign" v-if="isCommitValue==1">
          <!--          id="sign_title"-->
          <div class="sign_title"  ref="sign_title" :id="10">
            {{$t('tabs.sign_up')}}
            <span class="sign_more"><a :href="'/#/signList'" style="color: gray;font-size: 15px;">{{$t('tabs.more')}}</a></span>
            <div class="sign_line"></div>
          </div>
          <div class="bullist" >
            <ul>
              <li v-for="(item,index) in signList" >
                <div class="date" v-if="index < 10">
                  <p class="day">{{item.month}}-{{item.day}}</p>
                  <p class="year">{{item.year}}</p>
                </div>
                <div class="text" >
                  <a :href="'/#/signDetailShow?id='+item.id" style="color: black">
                    {{item.firstName+item.lastName}}
                  </a>
                  <div  v-if="index==0"  style="float: right;margin-right: 20px;background: rgb(156,0,0);height: 18px;width:36px;border-radius: 3px;"><span style="color: #dcdfe6;font-size: 12px;line-height: 18px;display: flex;justify-content: center;">new</span></div>
                </div>
                <!--                <span style="float: right;padding-right: 20px">{{'审核状态: '+item.shenhe}}</span>-->
              </li>

            </ul>
          </div>

        </div>

      </div>
    </div>
    <el-dialog v-model="showQQgroup" :center="true" :close-on-click-modal="false" :close-on-press-escape="false" width="40%">
      <div style="font-size: 30px;margin-bottom: 20px;">{{ $i18n.t('menus.joinQQ') }}</div>
      <div style="display: flex; justify-content: center;">
        <img src="@/assets/qqGroupCode.jpg" alt="" style="width: 400px; height: 500px;">
      </div>
    </el-dialog>
  </div>
</template>
<script>
const Base64 = require('js-base64').Base64
import time from '@/core/time.js';
import globalData from "@/util/globalData";
export default {
  computed: {
    isCommitValue() {
      // 检查 isCommit cookie 的值
      return globalData.isCommit ===1?1:0
    },
  },
  data() {
    return {
      vediourl:'',
      currentTime:'',
      show:false,
      year:'',
      month:'',
      day:'',
      content:'',
      isRight:'',
      tech_name: 'tech',
      notices_name:'notices',
      achievements_name:'achievements',
      techDemands_name:'techDemands',
      recommand_name:'recommand',
      discuss_name:'discuss',
      techAll:[],
      assesshp:[],
      State:'',
      radio: '',
      totalNum: 0, pageNum: 1, pageSize: 5,
      news: [],
      announce:[],
      achi:[],
      policy: [],
      cases: [],
      tech:[],
      assess:[],
      smartRec:[],
      requirement:[],
      fileDownload:[],
      signList:[],
      imges: [

      ],
      loginVisible: false,
      loginTitle: "登录",
      loginFlag: true,
      register: {
        userName: '',
        loginName: '',
        password1: '',
        password2: '',
        email: '',
        type: '',
      },
      loginForm: {
        loginName: '',
        password: '',
      },
      remember: false,//记住密码
      titleFlag: false,//判断title
      showQQgroup: false,//展示群聊二维码
    }
  },
  created() {
    this.getSignList();
    this.getVedioUrl();
    this.getCarouselchart();
    this.getCurrentTime();
    this.techSelect();
    this.RequirementSelect();
    this.FileSelect();
    this.newsSelect();
    this.announceSelect();
    this.AchievementSelect();
    this.policySelect();
    this.getImages();
    // this.getSmartRec();
    this.assessSelect();
    //在页面加载时从cookie获取登录信息
    let loginName = this.$cookies.get("loginName")
    // 如果存在赋值给表单，并且将记住密码勾选
    if (loginName) {
      let password = Base64.decode(this.$cookies.get("password"))
      this.loginForm.loginName = loginName
      this.loginForm.password = password
      this.remember = true
    }

  },
  mounted() {
  },
  beforeDestroy() {

  },

  watch: {
    loginFlag: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$nextTick(() => {
            // this.$refs.psswordLogin.style.borderBottom = "2px solid #1269FF";
            // this.$refs.register.style.border = "none";
          })
        } else {
          this.$nextTick(() => {
            // this.$refs.register.style.borderBottom = "2px solid #1269FF";
            // this.$refs.psswordLogin.style.borderBottom = "none";
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    goToShow(){
      document.getElementById("showSign").scrollIntoView();
      // console.log("this.$parent:",this.$parent.$parent.$parent.$parent.sonChangeSign1())
      this.$parent.$parent.$parent.sonChangeSign1();
      // debugger

      /*或
      document.querySelector("#idshow").scrollIntoView();
      或
      this.$refs.view.scrollIntoView();
      */
    },

    goTotrainingApplication(){
      this.$router.push('/indextrainingApplication')
    },
    showCurrentDate() {
      this.$el.querySelector('.active').scrollIntoView({
        block: 'start',
      }) // 回到顶部
    },


    //文件下载
    //下载文件

    downloadFile(item) {

      window.open(
          window.location.origin+"/api3/"+item.url,
          '_self'
      );
    },
    getSmartRec(){
      let data = {
        pageNum: 1,
        pageSize: 8,
      };
      let url = '/arRequirement/getSmartRec';
      this.$request.post(url,data).then(data => {
        console.log("11111111111112",data);
        this.smartRec = data.obj;
        this.totalNum = data.obj;
      })
    },
    getVedioUrl(){
      let data = {
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        user:null,
      };
      let url = '/FileUpload/agricultureStarList';

      this.$request.post(url,data).then(data => {
        if (data.obj.list.length>0){
          this.vediourl =window.location.origin+'/api3/'+data.obj.list[0].url;
        }
        this.totalNum = data.obj.total;

        for(let item of this.news){
          item.year=item.createdDate.substring(0,4);
          item.month=item.createdDate.substring(5,7);
          item.day=item.createdDate.substring(8,10);
          item.createdDate = time.formateDate(item.createdDate);
        }
      })
    },
    getCarouselchart(){
      this.$request.post('/FileUpload/getCarouselChart',).then(res=>{
        this.imges=res.obj;
        for(let i=0;i<this.imges.length;i++){
          console.log('============',window.location)
          this.imges[i]=window.location.origin+'/api3/'+this.imges[i];
          console.log(this.imges[i])
        }
        console.log(this.imges)
      })
    },
    goToAgricultural(){
      this.$router.push('agricultureStarList')
    },
    getCurrentTime(){
      let y = new Date().getFullYear();
      this.year=y;
      let m = new Date().getMonth() + 1;
      this.month=m;
      let d = new Date().getDate();
      this.day=d;
      let h = new Date().getHours();
      let mm = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes(): new Date().getMinutes();
      let s =new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
      this.currentTime = y + "年" + m + "月" + d + "日" + "  " + h + ":" + mm + ":" + s;
      console.log("年",this.year)
      console.log("月",this.month)
      console.log("日",this.day)
      console.log("时间",this.currentTime)
    },


    //跳转页面
    jump(url) {
      this.$router.push(url);
    },
    jumpout(value){
      let url=value.content.replace(/<[^>]+>/g, "")
      console.log("地址",url)
      window.open(url,"_blank")
    },
    chooseUser() {
      console.log("radio", this.radio);
      this.register.type = this.radio;
      console.log("type", this.register.type);
    },
    //鼠标悬浮事件
    mouseOver(title) {
      if (this.titleFlag) return
      let doucment = document.getElementsByClassName("title");
      for (let item of doucment) {
        if (item.lastChild.innerHTML === title) {
          this.titleFlag = true;
          item.style.borderBottomStyle = "solid";
          item.style.borderBottomColor = "#3CA3E3";
          item.style.borderBottomWidth = "8px";
          item.style.color = "#3CA3E3"
          return
        }
      }
    },
    //鼠标离开事件
    mouseLeave(title) {
      this.titleFlag = false;
      let doucment = document.getElementsByClassName("title")
      for (let item of doucment) {
        if (item.lastChild.innerHTML === title) {
          item.style.borderBottomStyle = "";
          item.style.borderBottomColor = "";
          item.style.borderBottomWidth = "";
          item.style.color = "#909090";
          return
        }
      }

    },
    setUserInfo() {
      // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
      // 如果没有勾选，储存的信息为空
      if (this.remember) {
        this.$store.commit("handleLoginName", this.loginForm.loginName);
        // base64加密密码
        let password = Base64.encode(this.loginForm.password);
        this.$store.commit("handlePassword", password);
      } else {
        this.$store.commit("handleLoginName", "");
        this.$store.commit("handlePassword", "");
      }
    },
    login() {
      if (this.loginForm.loginName === '' || this.loginForm.password === '') {
        this.$message({
          message: '手机号或密码不能为空',
          type: 'warning'
        });
        return
      }
      let data = {
        loginName: this.loginForm.loginName,
        password: this.loginForm.password
      }
      let url = '/login/login'
      this.$request.post(url, data).then((data) => {
        let loginInfo = data.obj
        if (loginInfo.result === "success") {
          this.setUserInfo();
          this.$store.commit("handleUserName", loginInfo.username);
          this.$store.commit("handleUserRole", loginInfo.role);
          this.$store.commit("handleUserId", loginInfo.id);
          // if (loginInfo.role != 'common') {
          //   this.$store.commit("handleUserRoleId", loginInfo.userRoleId);
          // }
          this.$router.push("/first")
        } else {
          this.$message({
            message: '手机号或密码错误',
            type: 'warning'
          });
        }
      })
    },
    mregister() {
      if (this.register.userName == '') {
        this.$msg.warning('请输入用户名')
      } else if (this.register.loginName == '') {
        this.$msg.warning('请输入手机号')
      } else if (this.register.password1 == '' || this.register.password2 == '') {
        this.$msg.warning('请输入密码')
      } else if (this.register.type == '') {
        this.$msg.warning('请选择用户')
      } else if (this.register.password1 == this.register.password2) {
        let data = {
          type: this.register.type,
          loginName: this.register.loginName,
          password: this.register.password1,
          userName: this.register.userName,
          email: this.register.email,
        }
        let url = '/login/register'
        this.$request.post(url, data).then((data) => {
          if (data.obj.result == "success") {
            this.$router.push("/")
            this.$msg.warning('注册成功')
          } else {
            this.$message({
              message: '注册失败',
              type: 'warning'
            });
          }
        })
      } else {
        this.$msg.warning('请输入相同的密码')
      }
    },
    isShow(){
      this.show=true;
    },
    isNotShow(){
      this.show=false;
    },
    goToAnnounce(index){
      document.getElementById(index).scrollIntoView({ behavior: 'smooth' })
    },
    casesSelect(value) {
      return new Promise((res, rej) => {
        let url = "/typical/selectAllTypicalList";
        // this.$request.post(url).then(data => {
        //     for(let index in data.obj){
        //         if(index == 3)break;
        //         this.cases.push(data.obj[index])
        //     }
        //     for(let item of this.cases){
        //         item.createdDate = time.formateDate(item.createdDate);
        //     }
        //     for(let index in data.obj){
        //         if(index == 5)break;
        //         this.imges.push(data.obj[index])
        //     }
        //     res(this.imges)
        // })
      })
    },
    getImages() {
      this.casesSelect().then(res => {
        let url = "/typical/selectImgById";
        for (let item of res) {
          let data = {
            id: item.id
          }
          // this.$request.post(url,data).then(data => {
          //     item.imageStr = data.obj;
          // })
        }
      })
    },
    casesShow(value) {
      this.$router.push({
        path: '/casesShow',
        query: {
          // caseId : row.caseId
          caseId: value.id
        }
      });
    },
    newsSelect() {
      let data = {
        pageNum: 1,
        pageSize: 10,
        // lang: 'en',
        lang: this.$i18n.locale,
      };
      // //debugger
      let url = '/ArAnnounce/getAllAnnounce';
      this.$request.post(url,data).then(data => {
        this.news = data.obj.list;
        // console.log(this.news,"1231231213")
        // debugger
        this.totalNum = data.obj.total;
        for(let item of this.news){
          item.year=item.createdDate.substring(0,4);
          item.month=item.createdDate.substring(5,7);
          item.day=item.createdDate.substring(8,10);
          // this.$set(item,"year",item.createdDate.substring(0,4));
          // this.$set(item,"month",item.createdDate.substring(5,7));
          // this.$set(item,"day",item.createdDate.substring(8,10));
          item.createdDate = time.formateDate(item.createdDate);
        }
      })
    },
    announceSelect() {
      let data = {
        pageNum: 1,
        pageSize: 10,
        // lang: 'en',
        lang: this.$i18n.locale,
      };
      //debugger
      let url = '/ArAnnounce/getAllAnnounce2';
      this.$request.post(url,data).then(data => {
        this.announce = data.obj.list;
        // console.log('this.announce',this.announce)
        // debugger
        this.totalNum = data.obj.total;
        for(let item of this.announce){
          item.year=item.createdDate.substring(0,4);
          item.month=item.createdDate.substring(5,7);
          item.day=item.createdDate.substring(8,10);
          // this.$set(item,"year",item.createdDate.substring(0,4));
          // this.$set(item,"month",item.createdDate.substring(5,7));
          // this.$set(item,"day",item.createdDate.substring(8,10));
          item.createdDate = time.formateDate(item.createdDate);
        }
      })
    },
    getSignList() {
      let data = {
        pageNum: 1,
        pageSize: 10,
      };
      let url = '/Sign/getSignList';
      this.$request.post(url,data).then(data => {
        // //debugger
        this.signList = data.obj.list;
        console.log(this.signList,"1231231213")
        this.totalNum = data.obj.total;
        for(let item of this.signList){
          item.year=item.createdDate.substring(0,4);
          item.month=item.createdDate.substring(5,7);
          item.day=item.createdDate.substring(8,10);
          // this.$set(item,"year",item.createdDate.substring(0,4));
          // this.$set(item,"month",item.createdDate.substring(5,7));
          // this.$set(item,"day",item.createdDate.substring(8,10));
          item.createdDate = time.formateDate(item.createdDate);
          if(item.signState=='A') {
            item.shenhe="待审核"
          }
          else if(item.signState=='B') {
            item.shenhe="通过"
          }
          else if(item.signState=='C') {
            item.shenhe="不通过"
          }
        }
      })
    },
    assessSelect() {
      let data = {
        pageNum: 1,
        pageSize: 6,
      };
      let url = '/ArAssess/getAssess';
      this.$request.post(url,data).then(data => {

        this.assess = data.obj.list;
        this.totalNum = data.obj.total;
        for(let item of this.assess){
          item.year=item.createdDate.substring(0,4);
          item.month=item.createdDate.substring(5,7);
          item.day=item.createdDate.substring(8,10);
          // this.$set(item,"year",item.createdDate.substring(0,4));
          // this.$set(item,"month",item.createdDate.substring(5,7));
          // this.$set(item,"day",item.createdDate.substring(8,10));
          item.createdDate = time.formateDate(item.createdDate);
        }
      })
      let data2={
        pageNum: 1,
        pageSize: 5,
      };
      let url2='/ArAssess/getAllAssessHp';
      this.$request.post(url2,data2).then(data =>{
        console.log("kdvnfkdjnvkfdv");
        this.assesshp = data.obj.list;
      })
    },
    AchievementSelect() {
      let data = {
        pageNum: 1,
        pageSize: 8,
        type: 3,
      };
      let url = '/PageNews/getAllPageNews';
      this.$request.post(url,data).then(data => {
        data.obj.list[0].tu=1;
        data.obj.list[1].tu=2;
        data.obj.list[2].tu=3;
        data.obj.list[3].tu=4;
        data.obj.list[4].tu=5;
        this.achi = data.obj.list;
        this.totalNum = data.obj.total;
        for(let item of this.achi){
          item.year=item.createdDate.substring(0,4);
          item.month=item.createdDate.substring(5,7);
          item.day=item.createdDate.substring(8,10);
          // this.$set(item,"year",item.createdDate.substring(0,4));
          // this.$set(item,"month",item.createdDate.substring(5,7));
          // this.$set(item,"day",item.createdDate.substring(8,10));
          item.createdDate = time.formateDate(item.createdDate);
        }
      })
    },
    techSelect(){
      let data = {
        type:3,
        pageNum: 1,
        pageSize: 8,
      };
      let url = '/ArNews/getAllNewsS';
      this.$request.post(url,data).then(data => {
        // data.obj.list[0].tu=1;
        // data.obj.list[1].tu=2;
        // data.obj.list[2].tu=3;
        // data.obj.list[3].tu=4;
        this.tech = data.obj.list;
        this.totalNum = data.obj.total;
        //let i=1;
        for(let item of this.tech){
          item.year=item.createdDate.substring(0,4);
          item.month=item.createdDate.substring(5,7);
          item.day=item.createdDate.substring(8,10);
          item.createdDate = time.formateDate(item.createdDate);

          // while(i<=5){
          //   if(item.coverUrl!=NULL){
          //     this.coverUrll.push(item);
          //     i++;
          //   }
          // }
          // if(item.isReprint==2){
          //   item.content=item.content.replace(/<[^>]+>/g, "")
          // }
        }
      })
      let data1={
        type:3,
        pageNum: 1,
        pageSize: 5,
      };
      let url1='/ArNews/getAllNewsHp';
      this.$request.post(url1,data1).then(data =>{
        console.log("kdvnfkdjnvkfdv",data);
        for(let item of data.obj.list){
          item.coverUrl=window.location.origin+item.coverUrl
        }
        this.techAll = data.obj.list;
      })

    },
    RequirementSelect(){
      let data = {
        pageNum: 1,
        pageSize: 8,
      };
      let url = '/arRequirement/getlists';
      this.$request.post(url,data).then(data => {
        console.log("requirement",data)
        data.obj.list[0].tu=1;
        data.obj.list[1].tu=2;
        data.obj.list[2].tu=3;
        data.obj.list[3].tu=4;
        data.obj.list[4].tu=5;
        data.obj.list[5].tu=6;
        this.requirement = data.obj.list;
        this.totalNum = data.obj.total;
        for(let item of this.requirement){
          item.year=item.createdDate.substring(0,4);
          item.month=item.createdDate.substring(5,7);
          item.day=item.createdDate.substring(8,10);
          item.createdDate = time.formateDate(item.createdDate);
          // if(item.isReprint==2){
          //   item.content=item.content.replace(/<[^>]+>/g, "")
          // }
        }
      })

    },
    FileSelect(){
      let data = {
        pageNum: 1,
        pageSize: 10,
        // fileType:'t',
      };
      // //debugger
      let url = '/FileUpload/selectDownloadFile';
      this.$request.post(url,data).then(data => {
        //debugger
        console.log("FileDownload",data)
        // data.obj.list[0].tu=1;
        // data.obj.list[1].tu=2;
        // data.obj.list[2].tu=3;
        // data.obj.list[3].tu=4;
        // data.obj.list[4].tu=5;
        // data.obj.list[5].tu=6;
        this.fileDownload = data.obj.list;
        this.totalNum = data.obj.total;
        console.log(this.fileDownload,'888')
        // //debugger
        for(let item of this.fileDownload){
          item.year=item.createdDate.substring(0,4);
          item.month=item.createdDate.substring(5,7);
          item.day=item.createdDate.substring(8,10);
          item.createdDate = time.formateDate(item.createdDate);
          // if(item.isReprint==2){
          //   item.content=item.content.replace(/<[^>]+>/g, "")
          // }
        }
      })

    },
    policySelect() {
      let data = {
        pageNum: 1,
        pageSize: 3,
      };
      let url = '/getallpolicy';
      // this.$request.post(url,data).then(data => {
      //     this.policy = data.obj.list;
      //     for(let item of this.policy){
      //         item.createdDate = time.formateDate(item.createdDate);
      //     }
      // })
    },
    showNews(value) {
      this.$router.push({
        path: '/newsShow',
        query: {
          id: value.id,
        }
      })
    },
    showAnnounce(value) {
      this.$router.push({
        path: '/announceShow',
        query: {
          id: value.id,
        }
      })
    },

    showPolicy(value) {
      this.$router.push({
        path: '/policyShow',
        query: {
          id: value.id,
        }
      })
    }


  },
};
</script>
<style lang="less">
html {
  zoom: 90%;
}
.show {
  height: 100%;
  width: 100%;

  .top {
    height: 450px;
    width: 100%;
    //background: url("../../assets/background.png") no-repeat;
    background-size: cover;
    .top_content {
      width: 1200px;
      margin: auto;
      .log_img {
        width: 100%;
        //height: 100%;
        // display: inline-block;
        vertical-align: middle;
        margin-right: 20px;
        margin-top: 35px;
        text-align: -webkit-center;
        //float: left;

        .el-carousel__container {
          width: 100%;
          height: 100%;
        }

        img:hover {
          cursor: pointer;
        }
      }
      .notices {
        //background: #9acdb3;
        //width: 780px;
        width: 100%;
        height: 700px;
        float: left;
        .notices_title {
          font-size: 18px;
          line-height: 40px;
          position: relative;
          border-bottom: #ddd 1px solid;
          font-weight: bold;
          .notices_more{
            float: right;
            padding-right: 10px;
          }

          .notices_line {
            width: 120px;
            height: 3px;
            background: #2f6556;
            overflow: hidden;
            position: absolute;
            left: 0;
            bottom: -2px;
          }
        }
        .bullist{
          height: 260px;
          margin-top: 10px;
          font-size: 15px;
          ul {
            height:260px;
            li{
              height:65px;
            }
          }
          ul li .date{
            width: 56px;
            float: left;
            text-align: center;
            margin-right: 15px;
            .day{
              line-height: 24px;
              background: #822a2a;
              height: 24px;
              color: #fff;
            }
            .year{
              height: 24px;
              line-height: 24px;
              border: #000000 1px solid;
              color: #000000;
            }
          }
          ul li .text{
            width: 90%;
            float: left;
            line-height: 20px;
          }
        }
      }
      .tech {
        //background: #9acdb3;
        //width: 380px;
        width: 100%;
        height: 700px;
        float: left;
        .tech_title {
          font-size: 18px;
          line-height: 40px;
          position: relative;
          border-bottom: #ddd 1px solid;
          font-weight: bold;
          .tech_more{
            float: right;
            padding-right: 10px;
          }

          .tech_line {
            width: 120px;
            height: 3px;
            background: #2f6556;
            overflow: hidden;
            position: absolute;
            left: 0;
            bottom: -2px;
          }
        }
        .bullist{
          a:hover{
            color: black;
            cursor:pointer;
          }
          height: 260px;
          margin-top: 10px;
          font-size: 15px;
          ul {
            height:260px;
            li{
              height:65px;
            }
          }
          ul li .date{
            width: 56px;
            float: left;
            text-align: center;
            margin-right: 15px;
            .day{
              line-height: 24px;
              background: #822a2a;
              height: 24px;
              color: #fff;
            }
            .year{
              height: 24px;
              line-height: 24px;
              border: #000000 1px solid;
              color: #000000;
            }
          }
          ul li .text{
            //width: 309px;
            width: 90%;
            float: left;
            line-height: 20px;
          }
        }
      }
      .sign {
        //background: #9acdb3;
        //width: 780px;
        width: 100%;

        height: 700px;
        float: left;
        .sign_title {
          font-size: 18px;
          line-height: 40px;
          position: relative;
          border-bottom: #ddd 1px solid;
          font-weight: bold;
          .sign_more{
            float: right;
            padding-right: 10px;
          }

          .sign_line {
            width: 120px;
            height: 3px;
            background: #2f6556;
            overflow: hidden;
            position: absolute;
            left: 0;
            bottom: -2px;
          }
        }
        .bullist{
          height: 260px;
          margin-top: 10px;
          font-size: 15px;
          ul {
            height:260px;
            li{
              height:65px;
            }
          }
          ul li .date{
            width: 56px;
            float: left;
            text-align: center;
            margin-right: 15px;
            .day{
              line-height: 24px;
              background: #822a2a;
              height: 24px;
              color: #fff;
            }
            .year{
              height: 24px;
              line-height: 24px;
              border: #000000 1px solid;
              color: #000000;
            }
          }
          ul li .text{
            width: 90%;
            float: left;
            line-height: 20px;
          }
        }
      }
      .blank1 {
        height: 30px;
        width: 100%;
        float: left;
      }
      .announce_left{
        position: fixed;
        left:0px;
        //top:50%;
        //bottom:0px;
        width: 280px;
        //margin-top: 20px;
        background: rgb(31, 56, 128);
        font-size: 40px;
        line-height: 40px;
        //text-align: center;
      }
      .announce{
        float: right;
        width: 100%;
        //height: 7500px;
        margin-bottom: 20px;
        .details-box{
          margin-top: 25px;
          font-size: 16px;
          line-height: 25px;
          text-align: left;
          img{
            align:center;
            max-width: 100%;
            max-height: 700px;
          }

        }
      }
      .achievements {
        //background: #9acdb3;
        width: 585px;
        height: 300px;
        float: left;
        .achievements_title {
          font-size: 18px;
          line-height: 40px;
          position: relative;
          border-bottom: #ddd 1px solid;
          font-weight: bold;
          .achievements_more{
            float: right;
            padding-right: 10px;
          }

          .achievements_line {
            width: 120px;
            height: 3px;
            background: #2f6556;
            overflow: hidden;
            position: absolute;
            left: 0;
            bottom: -2px;
          }
        }
        .achievements_list{

          margin-top: 10px;
          .achievements_obj{
            .title{
              width: 450px;
              color: black;
              overflow:hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              display: block;
            }

            line-height: 32px;
            .dot{
              width: 6px;
              height: 6px;
              background: #EF870C;
              border-radius: 6px;
              display: inline-block;
              margin: 0 8px 2px 0;
            }
            .achi_time{
              float: right;
              font-size: 14px;
              color: #aaa;
            }
          }
        }
      }
      .agriculturalStar{
        width: 585px;
        height: 300px;
        float: right;
        //background: #2D9F7F19;
        .agricultural_title {
          font-size: 18px;
          line-height: 40px;
          position: relative;
          border-bottom: #ddd 1px solid;
          font-weight: bold;
          .agricultural_more{
            float: right;
            padding-right: 10px;
          }

          .agricultural_line {
            width: 120px;
            height: 3px;
            background: #2f6556;
            overflow: hidden;
            position: absolute;
            left: 0;
            bottom: -2px;
          }
        }
        .agricultural_list{
          height:300px;
          width: 585px;
          text-align: center;
          object-fit: fill;
          video{
            width: 100%;
            height: 100%;

          }
        }
      }
      .techDemands {
        //background: #9acdb3;
        width: 585px;
        height: 300px;
        float: left;
        .techDemands_title {
          font-size: 18px;
          line-height: 40px;
          position: relative;
          border-bottom: #ddd 1px solid;
          font-weight: bold;
          .techDemands_more{
            float: right;
            padding-right: 10px;
          }

          .techDemands_line {
            width: 120px;
            height: 3px;
            background: #2f6556;
            overflow: hidden;
            position: absolute;
            left: 0;
            bottom: -2px;
          }
        }
        .techDemands_list{

          margin-top: 10px;
          .techDemands_obj{
            .title{
              width: 450px;
              color: black;
              overflow:hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              display: block;
            }

            line-height: 32px;
            .dot{
              width: 6px;
              height: 6px;
              background: #EF870C;
              border-radius: 6px;
              display: inline-block;
              margin: 0 8px 2px 0;
            }
            .achi_time{
              float: right;
              font-size: 14px;
              color: #aaa;
            }
          }
        }

      }
      .fileDownload {
        //background: #9acdb3;
        width: 585px;
        height: 300px;
        float: left;
        .fileDownload_title {
          font-size: 18px;
          line-height: 40px;
          position: relative;
          border-bottom: #ddd 1px solid;
          font-weight: bold;
          .fileDownload_more{
            float: right;
            padding-right: 10px;
          }

          .fileDownload_line {
            width: 120px;
            height: 3px;
            background: #2f6556;
            overflow: hidden;
            position: absolute;
            left: 0;
            bottom: -2px;
          }
        }
        .fileDownload_list{

          margin-top: 10px;
          .fileDownload_obj{
            .title{
              width: 450px;
              color: black;
              overflow:hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              display: block;
            }

            line-height: 32px;
            .dot{
              width: 6px;
              height: 6px;
              background: #EF870C;
              border-radius: 6px;
              display: inline-block;
              margin: 0 8px 2px 0;
            }
            .achi_time{
              float: right;
              font-size: 14px;
              color: #aaa;
            }
          }
        }

      }
      .trainingApplication {
        //background: #9acdb3;
        width: 585px;
        height: 300px;
        float: right;
        .trainingApplication_title {
          font-size: 18px;
          line-height: 40px;
          position: relative;
          border-bottom: #ddd 1px solid;
          font-weight: bold;
          .trainingApplication_more{
            float: right;
            padding-right: 10px;
          }

          .trainingApplication_line {
            width: 120px;
            height: 3px;
            background: #2f6556;
            overflow: hidden;
            position: absolute;
            left: 0;
            bottom: -2px;
          }
        }
        .trainingApplication_list{

          margin-top: 10px;
          .trainingApplication_obj{
            .title{
              width: 450px;
              color: black;
              overflow:hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              display: block;
            }

            line-height: 32px;
            .dot{
              width: 6px;
              height: 6px;
              background: #EF870C;
              border-radius: 6px;
              display: inline-block;
              margin: 0 8px 2px 0;
            }
            .achi_time{
              float: right;
              font-size: 14px;
              color: #aaa;
            }
          }
        }

      }
      .recommand {
        width: 585px;
        height: 300px;
        float: right;
        //background: rgba(0, 175, 123, 0.1);
        .recommand_title {
          font-size: 18px;
          line-height: 40px;
          position: relative;
          border-bottom: #ddd 1px solid;
          font-weight: bold;
          .recommand_more{
            float: right;
            padding-right: 10px;
          }

          .recommand_line {
            width: 120px;
            height: 3px;
            background: #2f6556;
            overflow: hidden;
            position: absolute;
            left: 0;
            bottom: -2px;
          }
          .recommand_list{

            margin-top: 10px;
            .recommand_obj{
              .title{
                width: 450px;
                color: black;
                overflow:hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                display: block;
              }

              line-height: 32px;
              .dot{
                width: 6px;
                height: 6px;
                background: #EF870C;
                border-radius: 6px;
                display: inline-block;
                margin: 0 8px 2px 0;
              }
              .achi_time{
                float: right;
                font-size: 14px;
                color: #aaa;
              }
            }
          }
        }
        .recommand_list{

          margin-top: 10px;
          .recommand_obj{
            .title{
              width: 450px;
              color: black;
              overflow:hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              display: block;
            }

            line-height: 32px;
            .dot{
              width: 6px;
              height: 6px;
              background: #EF870C;
              border-radius: 6px;
              display: inline-block;
              margin: 0 8px 2px 0;
            }
            .achi_time{
              float: right;
              font-size: 14px;
              color: #aaa;
            }
          }
        }
      }
      .judge {
        width: 100%;
        height: 300px;
        float: left;
        .judge_left{
          width: 410px;
          height: 300px;
          float: left;
          background: linear-gradient(137deg, #ee8383 0%, #bb0202 100%);

          .expert-title {
            font-size: 20px;
            color: #fff;
            margin-bottom: 10px;
            font-weight: bold;
            margin-top: 20px;
            margin-left: 10px;
          }
        }
        .judge_right{
          width: 790px;
          height: 300px;
          float: right;
          //background: rgba(243, 186, 42, 0.1);
          .judge_title {
            font-size: 18px;
            line-height: 40px;
            position: relative;
            border-bottom: #ddd 1px solid;
            font-weight: bold;
            margin-right: 20px;
            width: 95%;
            float: right;
            .judge_more{
              float: right;
              padding-right: 10px;
            }

            .judge_line {
              width: 120px;
              height: 3px;
              background: #2f6556;
              overflow: hidden;
              position: absolute;
              left: 0;
              bottom: -2px;
            }
          }
          .assess_list{
            margin-top: 42px;
            margin-left: 20px;
            height : 258px;
            ul{
              margin-top: 52px;
              height : 248px;
              li{
                height : 43px;
              }
            }
          }

        }
      }

      .login {
        overflow-y: scroll;
        margin-left: 200px;
        width: 400px;
        height: 320px;
        background: white;
        float: left;
        margin-top: 70px;
        border-radius: 20px;
        box-shadow: 0px 0px 0px 20px #70A0F1;

        .el-input__inner {
          border: 2px solid #78AAFF;
        }

        .el-input__prefix {
          color: #78AAFF;
        }

        .login_tab {
          height: 60px;
        }

        .login_tab_item1 {
          float: left;
          margin-top: 30px;
          margin-left: 80px;
          padding-bottom: 20px;
        }

        .login_tab_item2 {
          float: right;
          margin-top: 30px;
          margin-right: 80px;
          padding-bottom: 20px;
        }

        .login_tab_item1:hover {
          cursor: pointer;
        }

        .login_tab_item2:hover {
          cursor: pointer;
        }

        .el-form-item__content {
          margin-left: 0;
        }

        .remember {
          height: 20px;
          line-height: 20px;
          font-size: 12px;
          margin-left: 40px;

          .el-checkbox {
            color: #CCCCCC;
          }
        }

        .login_button {
          width: 200px;
          background: #1269FF;
          margin-left: 100px;
          margin-top: 20px;
          box-shadow: 0px 20px 10px -10px #CBDEFF;
        }
      }
    }
  }

  .tab_title {
    height: 100px;
    width: 100%;
    background: white;
    border-bottom: 8px solid #D5E4F9;

    .tab_title_box {
      width: 1350px;
      height: 100px;
      margin: auto;

      .title_box {
        width: 430px;
        height: 100px;
        margin-left: 20px;
        float: left;

        .title {
          font-size: 18px;
          font-weight: bold;
          color: #909090;
          width: 230px;
          margin: auto;
          height: 100px;
          line-height: 100px;
          text-align: center;
          padding-right: 20px;

          img {
            height: 35px;
            width: 35px;
            margin-right: 5px;
            vertical-align: middle;
          }
        }
      }
    }
  }

  .content {
    width: 100%;
    height: 700px;

    .jump {
      position: absolute;
      left: 175px;
      bottom: 0;
    }

    .jump:hover {
      cursor: pointer;
    }

    .case_box {
      background: white;
      width: 430px;
      height: 350px;
      margin-top: 20px;
      margin-left: 20px;
      display: inline-block;
      vertical-align: middle;
      font-family: "Microsoft YaHei";
      box-shadow: 0px 0px 10px 2px #d0d2d3;
      border-radius: 20px;
      position: relative;

      .case {
        padding: 5px 0;
        font-size: 18px;
        height: 60px;
        width: 390px;
        margin-left: 20px;
        margin-top: 15px;
        border-bottom: 2px solid #E2E6F1;

        .case_title {
          display: inline-block;
          overflow: hidden;
          width: 20pc;
          color: black;
          margin-left: 20px;
          margin-top: 10px;
          vertical-align: middle;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        .case_date {
          color: black;
          margin-top: 10px;
          vertical-align: middle;
        }
      }

      .case:hover {
        cursor: pointer;
      }
    }

    .news_box {
      background: white;
      width: 430px;
      height: 350px;
      margin-top: 20px;
      margin-left: 20px;
      display: inline-block;
      vertical-align: middle;
      font-family: "Microsoft YaHei";
      box-shadow: 0px 0px 10px 2px #d0d2d3;
      border-radius: 20px;
      position: relative;

      .news {
        padding: 5px 0;
        font-size: 18px;
        height: 60px;
        width: 390px;
        margin-left: 20px;
        margin-top: 15px;
        border-bottom: 2px solid #E2E6F1;

        .news_title {
          display: inline-block;
          overflow: hidden;
          width: 20pc;
          color: black;
          margin-left: 20px;
          vertical-align: middle;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          margin-left: 20px;
          margin-top: 10px;
        }

        .news_date {
          color: black;
          margin-top: 10px;
          vertical-align: middle;
        }
      }

      .news:hover {
        cursor: pointer;
      }
    }

    .policy_box {
      background: white;
      width: 430px;
      height: 350px;
      margin-top: 20px;
      margin-left: 20px;
      display: inline-block;
      vertical-align: middle;
      font-family: "Microsoft YaHei";
      box-shadow: 0px 0px 10px 2px #d0d2d3;
      border-radius: 20px;
      position: relative;

      .policy {
        padding: 5px 0;
        font-size: 18px;
        height: 60px;
        width: 390px;
        margin-left: 20px;
        margin-top: 15px;
        border-bottom: 2px solid #E2E6F1;

        .policy_title {
          display: inline-block;
          overflow: hidden;
          width: 20pc;
          color: black;
          margin-left: 20px;
          vertical-align: middle;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          margin-left: 20px;
          margin-top: 10px;
        }

        .policy_date {
          color: black;
          margin-top: 10px;
          vertical-align: middle;
        }
      }

      .policy:hover {
        cursor: pointer;
      }
    }
  }

}
</style>
